import React from 'react';
import { Link } from 'react-router-dom';
import Iso3D from './Iso3D';
import { IsoIllustration } from './IsoSvg';
import { Icon } from '../ui';
import { FACTS, SITE } from '../../config/siteConfig';
import '../../css/iso.css';

/**
 * 메인 히어로 — 파이버 레이저 절단 셀 디오라마.
 * 왼쪽 카피, 오른쪽 3D 무대. 무대 위에 사양 태그(HUD)를 띄워 "실제 공정"임을 읽게 한다.
 */
export default function IsoHero() {
  return (
    <header className="ih">
      <div className="ih-bg" aria-hidden="true">
        <div className="iso-grid-bg iso-grid-bg--flat" />
      </div>
      <div className="wrap ih-in">
        <div className="ih-copy">
          <div className="kicker kicker--spark rise">{SITE.region} · Fibre laser</div>
          <h1 className="ih-title rise rise-1">
            Precision cut,
            <em>plate by plate.</em>
          </h1>
          <p className="ih-lede rise rise-2">
            Upload a DXF and get an indicative price on the spot — material, thickness, cut length and pierce count are
            read straight from your drawing, then confirmed by an estimator within 24 hours.
          </p>
          <div className="ih-cta rise rise-3">
            <Link to="/quote" className="btn btn-p btn-lg">
              <Icon name="upload" />
              Upload DXF for a quote
            </Link>
            <Link to="/materials" className="btn btn-s btn-lg">
              See materials
            </Link>
          </div>
          <dl className="ih-facts rise rise-4">
            {FACTS.map(f => (
              <div key={f.label}>
                <dt>
                  {f.value}
                  <span>{f.unit}</span>
                </dt>
                <dd>{f.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="ih-stage rise rise-2">
          <div className="ih-stage-ground" aria-hidden="true" />
          <Iso3D kind="cell" live parallax maxDpr={1.6} className="ih-canvas">
            <IsoIllustration scene="cell" className="ih-fallback" />
          </Iso3D>
          <div className="ih-hud ih-hud--tl" aria-hidden="true">
            <span className="ih-live" />
            cell 02 · cutting
          </div>
          <div className="ih-hud ih-hud--tr" aria-hidden="true">
            SS304 · 2.0 mm
            <br />
            3000 × 1500
          </div>
          <div className="ih-hud ih-hud--bl" aria-hidden="true">
            N₂ assist · kerf 0.15 mm
            <br />
            orthographic · 30°
          </div>
        </div>
      </div>
    </header>
  );
}
